import { Component, inject, model } from '@angular/core';

import { ModalService } from '../../../services';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-ok-cancel-modal',
  templateUrl: './ok-cancel-modal.component.html',
  styleUrl: './ok-cancel-modal.component.scss',
  imports: [SummaryTopComponent],
})
export class OkCancelModalComponent {
  private readonly modalService = inject(ModalService);

  public readonly header = model<string>();
  public readonly message = model<string>();
  public readonly okLabel = model($localize`Ok`);

  onOk() {
    this.modalService.close();
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
